import { deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { FirestoreDB } from '../../../utils/firebase/firebase';

const useReminderHandlers = (
  filteredReminders,
  setFilteredReminders,
  fetchReminders
) => {
  const deleteReminderInFirebase = async (reminderId, patientId) => {
    try {
      if (!reminderId || !patientId) {
        console.error('Missing reminderId or patientId');
        return;
      }

      const reminderRef = doc(
        FirestoreDB,
        'notifications',
        patientId,
        'reminders',
        reminderId
      );
      await deleteDoc(reminderRef);

      setFilteredReminders((prevReminders) =>
        prevReminders.map((patient) => {
          if (patient.id === patientId) {
            return {
              ...patient,
              reminders: patient.reminders.filter(
                (reminder) => reminder.id !== reminderId
              ),
            };
          }
          return patient;
        })
      );
      await fetchReminders();
      console.log('delete successful');
    } catch (error) {
      console.log('Error deleting document:', error);
    }
  };

  const updateReminderActiveHandler = async (
    reminderId,
    patientId,
    checked
  ) => {
    await updateDoc(
      doc(FirestoreDB, 'notifications', patientId, 'reminders', reminderId),
      {
        active: checked,
      }
    );
    return true;
  };

  const handleActiveReminderChange = (reminderId, patientId, checked) => {
    const tempReminders = [...filteredReminders];
    const patientReminders = tempReminders.find(
      (patientData) => patientData?.id === patientId
    );

    if (!patientReminders?.reminders) {
      console.error('Patient reminders not found');
      return;
    }

    const reminder = patientReminders.reminders.find(
      (reminder) => reminder?.id === reminderId
    );

    if (!reminder) {
      console.error('Reminder not found');
      return;
    }

    reminder.active = checked;
    updateReminderActiveHandler(reminderId, patientId, checked);
    setFilteredReminders(tempReminders);
  };

  return {
    deleteReminderInFirebase,
    handleActiveReminderChange,
  };
};

export default useReminderHandlers;
